<template>
  <a-drawer
    width="50%"
    :visible="visible"
    @close="handleClose"
    :title="detailTitle"
  >
    <a-divider orientation="left">
      <b>处理记录详情</b>
    </a-divider>
    <a-descriptions :column="1" bordered>
      <a-descriptions-item label="处理人">
        {{ detailForm.handleName || '-' }}
      </a-descriptions-item>

      <a-descriptions-item label="照片">
        <div v-if="detailPhotoList.length > 0">
          <a-carousel
            :autoplay="detailPhotoList.length > 1"
            :dots="detailPhotoList.length > 1"
            arrows
            style="max-width: 600px; margin: 0 auto"
          >
            <div
              v-for="url in detailPhotoList"
              :key="url"
              class="photo-preview-slide"
            >
              <img
                :src="url"
                alt="照片"
                style="max-width: 100%; max-height: 400px; cursor: pointer"
                @click="openPhotoInNewTab(url)"
              />
              <a-button
                type="link"
                block
                @click="openPhotoInNewTab(url)"
                style="margin-top: 10px"
              >
                在新窗口打开
              </a-button>
            </div>
          </a-carousel>
        </div>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item label="响应时间">
        {{ parseTime(detailForm.handleTime) || '-' }}
      </a-descriptions-item>
    </a-descriptions>
  </a-drawer>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 处理记录详情组件
 * 功能：展示处理记录的详细信息
 * - 处理人、情况描述、照片、响应时间
 * - 照片支持走马灯预览和新窗口打开
 */
import { getComplaintHandle } from '@/api/system/complaintHandle'
import { parseTime as formatTime } from '@/utils/ruoyi'

export default {
  name: 'ComplaintHandleDetail',
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 处理记录ID
    handleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // 详情标题
      detailTitle: '处理记录详情',
      // 详情表单数据
      detailForm: {
        id: null,
        handleName: null,
        remark: null,
        url: null,
        handleTime: null,
      },
    }
  },
  computed: {
    /**
     * 详情照片列表
     * 将 url 字符串（逗号分隔）转换为数组
     */
    detailPhotoList() {
      return this.detailForm.url
        ? this.detailForm.url.split(',').filter(Boolean)
        : []
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开且处理记录ID存在时，加载详情数据
     */
    visible(newVal) {
      if (newVal && this.handleId) {
        this.loadDetail()
      }
    },
    /**
     * 监听处理记录ID变化
     * 当处理记录ID变化且弹窗打开时，重新加载详情数据
     */
    handleId(newVal) {
      if (newVal && this.visible) {
        this.loadDetail()
      }
    },
  },
  methods: {
    /**
     * 加载详情数据
     * 根据处理记录ID调用API获取详情
     */
    loadDetail() {
      if (!this.handleId) {
        this.$message.warning('处理记录ID不能为空', 3)
        return
      }
      getComplaintHandle({ id: this.handleId })
        .then((response) => {
          if (response && response.data) {
            this.detailForm = {
              id: response.data.id,
              handleName: response.data.handleName || null,
              remark: response.data.remark || null,
              url: response.data.url || null,
              handleTime: response.data.handleTime || null,
            }
          } else {
            this.$message.error('获取处理记录详情失败', 3)
          }
        })
        .catch(() => {
          this.$message.error('获取处理记录详情失败，请稍后重试', 3)
        })
    },

    /**
     * 关闭详情弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      this.detailForm = {
        id: null,
        handleName: null,
        remark: null,
        url: null,
        handleTime: null,
      }
      $emit(this, 'close')
    },

    /**
     * 在新窗口打开照片
     * @param {String} url - 照片URL
     */
    openPhotoInNewTab(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    /**
     * 时间格式化（复用工具函数）
     * @param {String|Date} time - 时间
     * @returns {String} 格式化后的时间字符串
     */
    parseTime(time) {
      return formatTime(time)
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
.photo-preview-slide {
  text-align: center;
  padding: 20px;
}
.photo-preview-slide img {
  display: block;
  margin: 0 auto;
  border-radius: 4px;
}
</style>
